// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1peJT","name":"Header_name__ws3x4","birthday":"Header_birthday__1mvdU","skeleton":"Header_skeleton__leGX3"};